module.exports = __webpack_public_path__ + "img/endless-logo.ee8631c3.png";